// filepath: c:\Users\gelis\Documents\GitHub\PisikolojiWeb\frontend\src\hooks\useAdminInfo.js
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAdminInfo, reset } from '../features/adminInfo/adminInfoSlice';

/**
 * Bu hook, admin bilgilerini Redux store'dan çeker.
 * Veri henüz yüklenmemişse, getAdminInfo eylemini tetikler.
 * @returns {{info: object, isLoading: boolean, isError: boolean}}
 */
export const useAdminInfo = () => {
  const dispatch = useDispatch();
  const { info, isLoading, isError } = useSelector((state) => state.adminInfo);

  useEffect(() => {
    // Eğer store'da 'info' verisi yoksa, API'den çek.
    // Bu, verinin gereksiz yere tekrar tekrar çekilmesini önler.
    if (!info) {
      dispatch(getAdminInfo());
    }

    // Bu hook'u kullanan bileşen unmount olduğunda reset'lemek
    // bazı durumlarda istenmeyebilir. Şimdilik kapalı bırakıyoruz.
    // return () => {
    //   dispatch(reset());
    // };
  }, [dispatch, info]);

  return { info, isLoading, isError };
};